/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import FieldsetProps from "./FieldsetProps";

export default class FieldsetModel {
    public constructor(private readonly _props: FieldsetProps) {}

    public get caption(): React.ReactNode | undefined {
        return this._props.caption;
    }

    public get children(): React.ReactNode {
        return this._props.children;
    }
}
